import { Component, OnInit } from '@angular/core';
import { AuthService } from '../auth/auth.service';
import { Router, NavigationStart, NavigationEnd } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';

@Component({
    selector: 'app-maintenance',
    templateUrl: './maintenance.component.html',
    styleUrls: ['./maintenance.component.scss'],
    standalone: false
})
export class MaintenanceComponent implements OnInit {
  constructor(private authService: AuthService, private router: Router, private spinner: NgxSpinnerService) {}

  ngOnInit() {
    // check for maintenance_mode and redirect
    const formData = {};
    this.authService.settingsAPI(1, formData).subscribe(data => {
      if (data.status) {
        data.systemSettings.map(item => {
          if (item.settings_key === 'maintenance_mode') {
            // check for maintenance key
            if (Number(item.settings_value) === 0) {
              this.router.navigate(['/']);
            } else {
              this.spinner.hide();
            }
          }
        });
      }
    });
  }
}
